import pollApi from './poll'
import categoryApi from './category'

const pollProgress = {
  getDetail(pk, params, context) {
    /*
     * Returns the poll with progress for whole poll and list of categories
     * with progress for each one.
     */
    const pollPromise = pollApi.getDetail(pk, params, context)
    const categoriesPromise = categoryApi.getListForPoll(pk, params, context)

    return Promise.all([pollPromise, categoriesPromise]).then(
      ([poll, categories]) => ({
        ...poll,
        categories,
      })
    )
  },
}

export default pollProgress
